<label
  [attr.for]="forId || null"
  class="app-label"
  [ngClass]="['app-label--' + (size || 'md'), customClass]"
>
  <span *ngIf="icon" class="app-label__icon">
    <img [src]="icon" alt="" />
  </span>
  <span class="app-label__text" *ngIf="cleanText">{{ cleanText }}</span>
  <span *ngIf="mandatory" class="app-label__mandatory" aria-hidden="true">*</span>
  <span *ngIf="optional" class="app-label__optional"> (optional)</span>
  <span
    *ngIf="tooltip"
    class="app-label__tooltip"
    [matTooltip]="tooltip"
    matTooltipPosition="above"
  >
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0-1A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0-4.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 8 9.5zm0-6a2.25 2.25 0 0 1 2.25 2.25c0 .77-.44 1.34-1.03 1.76l-.16.11c-.48.33-.81.65-.81 1.13a.75.75 0 0 1-1.5 0c0-.98.62-1.55 1.19-1.95l.13-.09c.45-.32.68-.62.68-1.01a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75.75.75 0 0 1-1.5 0A2.25 2.25 0 0 1 8 3.5z"
      />
    </svg>
  </span>
</label>
